angular.module('v3sWbtPlayerApp').filter('translate', ['v3sI18nService',function (v3sI18nService) {

    //Falls Übersetzungen noch nicht geladen sind, dann wird es später nochmal geprüft
    translate.$stateful = true;
    function translate(input, placeholders) {
        var translationValue = "";
        if (!!input) {
            var load = v3sI18nService.loadLibrary();
            if (load == true) {
                translationValue = v3sI18nService.getText(input, placeholders);
            } else {
                load.then(function () {
                    translationValue = v3sI18nService.getText(input, placeholders);
                });
            }
        }
        return translationValue.trim();
    };

    return translate;
}]);